import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { AxiosInstance } from "axios";
import { createContext, useEffect, useState } from "react";
import styled from "styled-components";
import { User } from "./_core/types";
import apiClient from "./_core/utils/apiClient";
import { AppRouting } from "./features/Routing/AppRouting";
import { AuthenticationRouting } from "./features/Routing/AuthenticationRouting";
import "./styles/App.css";
import "./styles/App.less";

const EmptySpace = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: white;
`;

interface UserContextInterface {
  user: User | null;
  setUser(value: User | null): void;
  loading: boolean;
}
//@ts-ignore
export const UserContext = createContext<UserContextInterface>();

interface ApiClientContextInterface {
  apiClient: AxiosInstance;
}
//@ts-ignore
export const ApiClientContext = createContext<ApiClientContextInterface>();

export default function App() {
  const [loading, setLoading] = useState<boolean>(true);
  const [user, setUser] = useState<User | null>(null);

  const getUserData = async () => {
    try {
      const { data } = await apiClient.get(`/api/account`);
      setUser(data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      getUserData();
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, loading }}>
      <ApiClientContext.Provider
        value={{
          apiClient,
        }}
      >
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: "5em" }} spin />}
          spinning={loading}
        >
          {loading ? (
            <EmptySpace />
          ) : user ? (
            <div className="fade-in">
              <AppRouting />
            </div>
          ) : (
            <div className="fade-in">
              <AuthenticationRouting />
            </div>
          )}
        </Spin>
      </ApiClientContext.Provider>
    </UserContext.Provider>
  );
}
